import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSingleFlange = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 5,
	height: 50,
	viewBox: "0 0 5.0 50.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 2.5 0.0 L 2.5 50.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgSingleFlange;
